import { mount } from '../../../js/dom-lifecycle';

mount('.form-floating-label label', function () {
    const $label = $(this);
    const $control = $(this).closest('.form-group').find('.form-control');
    const update = () => $label.toggleClass('focused-label', $control.is(':focus') || $control.val() != '');

    update();
    $control.on('focus focusout input', update);
});

$('form').on('submit', function () {
    setTimeout(() => $(this.elements).filter('[type=submit]').prop('disabled', true));
});
